import classNames from "classnames";
import { ReactNode } from "react";

export interface TextProps {
  children: ReactNode;
  className?: string;
  bold?: boolean;
  thin?: boolean;
  italic?: boolean;
  underline?: boolean;
  sm?: boolean;
  lg?: boolean;
  xl?: boolean;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl";
}

export function Text({
  children,
  className,
  xl,
  sm,
  lg,
  size,
  bold = false,
  thin = false,
  italic = false,
  underline = false,
}: TextProps) {
  return (
    <p
      className={classNames(
        "dark:text-white",
        {
          "font-bold": bold,
          "font-thin": thin,
          italic: italic,
          underline: underline,
          "text-sm": sm || size === "sm",
          "text-lg": lg || size === "lg",
          "text-xl": xl || size === "xl",
          "text-2xl": size === "2xl",
          "text-3xl": size === "3xl",
          "text-4xl": size === "4xl",
          "text-5xl": size === "5xl",
        },
        className,
      )}
    >
      {children}
    </p>
  );
}
